import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const PricingTaskRunSummaryFieldsFragmentDoc = gql`
  fragment PricingTaskRunSummaryFields on PricingTaskRunSummaryByType {
    accepted_recommendations_count
    auto_publish_at
    description
    last_completed_at
    name
    overridden_recommendations_count
    pending_recommendations_count
    rejected_recommendations_count
    sort_order
    task_group
    task_type_id
    weekly_gp_impact_in_micros
  }
`;
export const GetPricingTaskRunsByTypeForBusinessOrganizationDocument = gql`
  query GetPricingTaskRunsByTypeForBusinessOrganization {
    getPricingTaskRunsByTypeForBusinessOrganization {
      task_runs {
        ...PricingTaskRunSummaryFields
      }
    }
  }
  ${PricingTaskRunSummaryFieldsFragmentDoc}
`;
export function useGetPricingTaskRunsByTypeForBusinessOrganizationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >(GetPricingTaskRunsByTypeForBusinessOrganizationDocument, options);
}
export function useGetPricingTaskRunsByTypeForBusinessOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >(GetPricingTaskRunsByTypeForBusinessOrganizationDocument, options);
}
export type GetPricingTaskRunsByTypeForBusinessOrganizationQueryHookResult =
  ReturnType<typeof useGetPricingTaskRunsByTypeForBusinessOrganizationQuery>;
export type GetPricingTaskRunsByTypeForBusinessOrganizationLazyQueryHookResult =
  ReturnType<
    typeof useGetPricingTaskRunsByTypeForBusinessOrganizationLazyQuery
  >;
export type GetPricingTaskRunsByTypeForBusinessOrganizationQueryResult =
  Apollo.QueryResult<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >;

/**
 * Wrapped version of useGeneratedGetPricingTaskRunsByTypeForBusinessOrganizationQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetPricingTaskRunsByTypeForBusinessOrganizationQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >(GetPricingTaskRunsByTypeForBusinessOrganizationDocument, options);
}

/**
 * Wrapped version of useGeneratedGetPricingTaskRunsByTypeForBusinessOrganizationLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetPricingTaskRunsByTypeForBusinessOrganizationLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQuery,
    Types.GetPricingTaskRunsByTypeForBusinessOrganizationQueryVariables
  >(GetPricingTaskRunsByTypeForBusinessOrganizationDocument, lazyOptions);
}
